import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";


import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginRight: theme.spacing(1),
		flex: 1,
	},

	extraAttr: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

const ContactSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, "Muito pequeno!")
		.max(50, "Muito longo!")
		.required("Necessita"),
	number: Yup.string().min(8, "Muito curto!").max(50, "Muito Longo!"),
	cpf: Yup.string().min(11, "Muito pequeno!")
	.max(14, "Muito longo!"),
});

const ConfirmaCpf = ({ open, onClose, contactId, initialValues, onSave, avisaCpf }) => {
	const classes = useStyles();
	const isMounted = useRef(true);

	const initialState = {
		cpf: ""
	};

	const [contact, setContact] = useState(initialState);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		const fetchContact = async () => {
			if (initialValues) {
				setContact(prevState => {
					return { ...prevState, ...initialValues };
				});
			}

			if (!contactId) return;

			try {
				const { data } = await api.get(`/contacts/${contactId}`);
				if (isMounted.current) {
					setContact(data);
				}
			} catch (err) {
				toastError(err);
			}
		};

		fetchContact();
	}, [contactId, open, initialValues]);

	const handleClose = () => {
		onClose();
		setContact(initialState);
	};

	const handleSaveContact = async values => {

		try {

			if(values.cpf.length >= 11){
				if (contactId) {
					await api.put(`/contacts/${contactId}`, values);
					handleClose();
				} else {
					const { data } = await api.post("/contacts", values);
					if (onSave) {
						onSave(data);
					}
					handleClose();
				}
				toast.success('Foi atualizado o cpf. Iniciando atendimento.');
			
				const newWindow = window.open(`https://crm.lamp-services.com/painel?f=vendas-atendimentov2&CliCpf=${values.cpf}&autoIniciar=true&AteTipo=5`, '_blank', 'noopener,noreferrer')
				if (newWindow) newWindow.opener = null
		
			}else{
				toast.warn('Para iniciar um atendimento, precisa colocar um cpf!');
			}


			
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className={classes.root}>
			<Dialog open={open} onClose={handleClose} maxWidth="lg">
				<DialogTitle id="form-dialog-title">
					Confirmação de CPF
				</DialogTitle>
				<Formik
					initialValues={contact}
					enableReinitialize={true}
					validationSchema={ContactSchema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSaveContact(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ values, errors, touched, isSubmitting }) => (
						<Form>
							<DialogContent dividers>
								<div>
									<Field
										as={TextField}
										label="Digite o CPF do cliente"
										name="cpf"
										placeholder="000.000.000-00"
										error={touched.cpf && Boolean(errors.cpf)}
										helperText={touched.cpf && errors.cpf}
										fullWidth
										margin="dense"
										variant="outlined"
									/>
								</div>								
							</DialogContent>
							<DialogActions>
								<Button
									onClick={handleClose}
									color="secondary"
									disabled={isSubmitting}
									variant="outlined"
								>
									Voltar
								</Button>
								<Button
									type="submit"
									color="primary"
									disabled={isSubmitting}
									variant="contained"
									className={classes.btnWrapper}
								>
									Iniciar Atendimento
								</Button>
							</DialogActions>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default ConfirmaCpf;
